import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=765cca55&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=765cca55&scoped=true&lang=scss&"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&lang=css&"
import style2 from "./BasicInfo.vue?vue&type=style&index=2&id=765cca55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765cca55",
  null
  
)

export default component.exports